import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

type listBinSizesResponse = {
  binSizes: string[];
};

export const listBinSizes = async () => {
  const response = await executeApiRequest(() => axios.get<listBinSizesResponse>("/requests/binsizes"));
  return response?.data.binSizes;
};
